// Copyright (c) 2022 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import {
   filterCollection,
    sortCollection
} from '../../../../shared/services/collections';
import Accordion from '../../../../shared/components/accordion';
import ClosingAccountFilterOptions from '../../services/closing-account-filter-options';
import ClosingAccountList from './closing-account-list';
import ClosingAccountSearchDealer from '../../state/closing-account-search-account';
import {FormattedMessage} from 'react-intl';
import SearchFilters from '../../../../shared/state/search-filters';
import {buildNumber} from '../../../../shared/services/build-number';

function handleFilterByChange(filterBy) {

    this.actions.updateClosingAccountListFilterBy(filterBy);

}

function handleSortByChange(sortBy) {

    this.actions.updateClosingAccountListSortBy(sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateClosingAccountListSortDirection(sortDirection);

}

class ClosingAccountAccordion extends Component {

    render() {

        let sortedCollection;

        sortedCollection = [...this.props.closingAccountChanges];

        sortedCollection = sortCollection(this.props.closingAccountSearchFilters.sortBy, this.props.closingAccountSearchFilters.sortDirection, sortedCollection);
        sortedCollection = filterCollection(this.props.closingAccountSearchFilters.filterBy, ClosingAccountFilterOptions, sortedCollection);
        const sortedCollectionLength = sortedCollection && sortedCollection.length;

        const title = (
            <FormattedMessage
                id='CLOSING_ACCOUNT_WITH_COUNT'
                values={{
                    count: buildNumber(sortedCollectionLength)
                }}
            />
        );

        const body = (
            <ClosingAccountList
                accountIndex={this.props.accountIndex}
                actions={this.props.actions}
                closingAccountChanges={sortedCollection}
                closingAccountSearchFilters={this.props.closingAccountSearchFilters}
                dealerSearchModal={this.props.isModalVisible}
                icon={true}
                isModalVisible={this.props.isModalVisible}
                isRequired={true}
                selectedDealers={this.props.selectedDealers}
                updateListFilterBy={this.props::handleFilterByChange}
                updateListSortBy={this.props::handleSortByChange}
                updateListSortDirection={this.props::handleSortDirectionChange}
            />
         );

        return (
            this.props.closingAccountChanges.length > 0 &&
            <Accordion
                accordionId='closing-account-accordion'
                body={body}
                title={title}
            />

        );

    }

}

ClosingAccountAccordion.displayName = 'ClosingAccountAccordion';
ClosingAccountAccordion.propTypes = {
    accountIndex: PropTypes.number,
    actions: PropTypes.object.isRequired,
    closingAccountChanges: PropTypes.arrayOf(PropTypes.instanceOf(ClosingAccountSearchDealer)).isRequired,
    closingAccountSearchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    isModalVisible: PropTypes.bool,
    length: PropTypes.number.isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(String))
};

export default ClosingAccountAccordion;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/closing-account/closing-account-accordion.js